// extracted by mini-css-extract-plugin
export default {"noprint":"_1jwiyauJUZMqcT-TQhmBYt"};